<template>
  <transition name="el-fade-in-linear">
    <div class="select-dialog-component" v-if="showModal">
      <hi-dialog class="dialog" :title="title" @close="showModal = false">
        <div class="modal">
          <div class="main-container">
            <div>
              <!-- <div class="type-title">10 schedules per month</div>s -->
              <select-item
                @click.native="itemClick(item)"
                model=""
                :type="item.type"
                v-for="item in list"
                :key="item.id"
                :item="item"
              ></select-item>
            </div>
          </div>
          <div class="bottom-container">
            <hi-button
              :disabled="!hasSelected"
              class="btn"
              @click.native="saveSelectClick"
              >Select</hi-button
            >
          </div>
        </div>
      </hi-dialog>
    </div>
  </transition>
</template>

<style lang="less" scoped>
.select-dialog-component {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
  .dialog {
    height: 700px;
  }
  .modal {
    width: 375px;
    height: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    .main-container {
      flex: 1;
      overflow: auto;
      .type-title {
        font-size: 16px;
        font-weight: 500;
        margin-top: 16px;
        padding-left: 15px;
        margin-bottom: 8px;
      }
    }
    .bottom-container {
      height: 64px;
      border-top: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        height: 36px;
        width: 335px;
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import hiButton from "../../common/button/Index";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";
import { mapGetters } from "vuex";
import selectItem from "./SelectItem";
import { mulModifyUnlimited } from "../../../service/publisher";
import { showErrorMsg } from "../../../utils/errors";
import { dateFormat } from "../../../utils/plugin_helper";

export default {
  name: "UnlimitedAutoSelectDialogComponent",
  components: { selectItem, hiDialog, hiButton },
  data() {
    return {
      showModal: false,
      selectIds: [],
      oldSelectIds: [],
    };
  },
  methods: {
    open() {
      this.showModal = true;
      this.selectIds = [];
    },
    /**
     * 选中事件
     */
    async itemClick(item) {
      // 如果是选中状态则改为未选中
      if (item.type === "select") {
        // 查看以选中项中是否包含点击项
        if (item.wasPremium) {
          const index = this.oldSelectIds.findIndex((id) => {
            return item.id === id;
          });
          if (index !== -1) {
            this.oldSelectIds.splice(index, 1);
          }
        } else {
          const index = this.selectIds.findIndex((id) => {
            return item.id === id;
          });
          if (index !== -1) {
            this.selectIds.splice(index, 1);
          }
        }
      }
      // 如果是未选中状态则改为选中
      if (item.type === "normal") {
        // // 判断当前是否为老账号
        if (item.wasPremium) {
          this.oldSelectIds.push(item.id);
        } else {
          this.selectIds.push(item.id);
        }
      }
      // 如果点击的是禁止点击则弹出升级提示
      if (item.type === "forbid") {
        // 所有未选中项中是否包含一个老账号
        const oldFull =
          this.list.filter((i) => i.type === "normal" && i.wasPremium)
            .length === 0;
        const upgradeBtnText = this.$t("common.upgrade");
        if (!oldFull) {
          // 获取国际化30天升级提示
          const date = dateFormat({
            date: this.user.plan.nextStartTime,
            format: "MMMM D, YYYY",
          });
          const dayLimitedText = this.$t(
            "addUnlimitedAccountPage.dayLimitedText",
            {
              date: date,
            }
          );
          try {
            await this.$msgbox({
              title: "",
              showCancelButton: true,
              message: dayLimitedText,
              distinguishCancelAndClose: true,
              confirmButtonText: upgradeBtnText,
              cancelButtonText: this.$t("common.contactUs"),
            });
            this.$router.push({ name: "UpgradePage" });
          } catch (action) {
            if (action === "cancel") {
              window.open(process.env.VUE_APP_CONTACT_US, "_blank");
            }
          }
        } else {
          let upgradeText = this.$t("addUnlimitedAccountPage.upgradeText", {
            number: this.user.plan.premiumInstagramPublisherCount,
          });
          // fb特殊提示
          if (item.socialNetwork === 2 || item.socialNetwork === 3) {
            upgradeText = `Support ${this.user.plan.premiumFacebookPublisherCount} Facebook. Upgrade your plan to get more.`;
          }
          // tw特殊提示
          if (item.socialNetwork === 4) {
            upgradeText = `Support ${this.user.plan.premiumTwitterPublisherCount} Twitter. Upgrade your plan to get more.`;
          }
          await this.$confirm.show({
            text: upgradeText,
            yesText: upgradeBtnText,
          });
          this.$router.push({ name: "UpgradePage" });
        }
      }
    },
    /**
     * select按钮点击事件
     */
    async saveSelectClick() {
      const loading = this.$loading();
      try {
        await mulModifyUnlimited({
          ids: [...this.selectIds, ...this.oldSelectIds],
        });
        this.showModal = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /** 允许添加的ins数量 */
    allowAddInsNum() {
      const insUserIds = this.selectIds.filter((id) => {
        // 找到选中项
        const select = this.user.linkedInstagramList.find((l) => l.id === id);
        if (select.socialNetwork === 1) {
          return true;
        }
        return false;
      });
      return this.user.premiumInstagramRemaining - insUserIds.length;
    },
    allowAddFbNum() {
      const fbUserIds = this.selectIds.filter((id) => {
        // 找到选中项
        const select = this.user.linkedInstagramList.find((l) => l.id === id);
        if (select.socialNetwork === 2 || select.socialNetwork === 3) {
          return true;
        }
        return false;
      });
      return this.user.premiumFacebookRemaining - fbUserIds.length;
    },
    allowAddTwNum() {
      const twUserIds = this.selectIds.filter((id) => {
        // 找到选中项
        const select = this.user.linkedInstagramList.find((l) => l.id === id);
        if (select.socialNetwork === 4) {
          return true;
        }
        return false;
      });

      return this.user.premiumTwitterRemaining - twUserIds.length;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组(过滤掉member和已选择的unlimited账号，同时去掉无密码用户)
      let list = [];
      this.user.linkedInstagramList
        .filter(
          (item) => !item.isMember && item.status !== 2 && !item.isUnlimited
        )
        .forEach((item) => {
          // 根据选中selectids判断该项是否选中
          const select =
            this.selectIds.find((id) => id === item.id) !== undefined ||
            this.oldSelectIds.find((id) => id === item.id) !== undefined;

          if (select) {
            item.type = "select";
          } else {
            console.log(item);
            if (item.wasPremium) {
              item.type = "normal";
            } else if (
              (item.socialNetwork === 1 && this.allowAddInsNum) ||
              ((item.socialNetwork === 2 || item.socialNetwork === 3) &&
                this.allowAddFbNum) ||
              (item.socialNetwork === 4 && this.allowAddTwNum)
            ) {
              item.type = "normal";
            } else {
              item.type = "forbid";
            }
          }
          list.push(item);
        });
      // 对列表进行排序 老账号排在前面 (wasPremium = true)，新账号排在后面
      list.sort((a, b) => {
        return a.wasPremium ? -1 : 1;
      });
      return list;
    },
    title() {
      let title = this.$t("myPlanPage.unlimitedInfo.title");
      return title;
    },
    /**
     *
     */
    unlimitedNum() {
      // 根据类型进行分组(只保留unlimited)
      const users = this.user.linkedInstagramList
        .filter((l) => l.isUnlimited && !l.isMember)
        .map((l) => {
          return {
            image: l.image,
            username: l.username,
          };
        });
      return users.length;
    },
    hasSelected() {
      return this.selectIds.length + this.oldSelectIds.length > 0;
    },
  },
};
</script>
